
export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'edtZakazkaNdRez';
export const NAME = 'ZakazkaRezervaceNd';
export const API_ND_AREA = 'Nd';
export const ZakazkaNd = 'ZakazkaNd';
export const NdSklad = 'NdSklad';
export const Ozakazka = 'Ozakazka';
export const DefualtQuantity = 0;
export const SERVICE_JOB_SPLIT_BILLING = 'ServiceJobSplitBilling';
export enum UOM {
	BARREL = 'Barrel',
	LITER = 'Liter',
}

export enum STOCK_STATUS {
	OUT_OF_STOCK = 'OutOfStock',
	STOCK_SHORTAGE = 'StockShortage',
}
export enum ADDITIONAL_WORK_STATUS {
	CUSTOMER_APPROVAL_PENDING = 'Customer Approval Pending',
	CUSTOMER_APPROVED = 'Customer Approved',
	CUSTOMER_REJECTED = 'Customer Rejected',
}
export enum ADDITIONAL_JOB_STATUS {
	PENDING = 0,
	ADDITIONAL = 1,
	NON_ADDITIONAL = 2,
	APPROVED = 3
}

export const ND_NR = 'ND_NR';
export const ZAKAZKA_NR = 'ZAKAZKA_NR';
export const X_VYROBEKND_OZN = 'X_VYROBEKND_OZN';
export const X_SKLAD_OZN = 'X_SKLAD_OZN';
export const X_ZAKAZKA_DRUH = 'X_ZAKAZKA_DRUH';
export const PART_MRP = 'PART_MRP';
export const RRP_UNIT_PRICE = 'RRP_UNIT_PRICE';
export const EAN_CODE = 'EAN_CODE';
export const X_REZERVVLASTNI = 'X_REZERVVLASTNI';
export const CONVERTED_UNIT_OF_MEASUREMENT = 'CONVERTED_UNIT_OF_MEASUREMENT';
export const SP_DISCOUNTED = 'SP_DISCOUNTED';
export const BASE_UNIT_OF_MEASUREMENT = 'BASE_UNIT_OF_MEASUREMENT'; 
export const CONVERTED_QUANTITY = 'CONVERTED_QUANTITY';
export const PRICE_PER_CONVERTED_QUANTITY ='PRICE_PER_CONVERTED_QUANTITY';
export const DISCOUNT_PERCENT='DISCOUNT_PERCENT';
export const TEXT = 'TEXT';
export const IS_ADDITIONAL = 'IS_ADDITIONAL';
export const SPLIT_BILLING = 'SplitBilling';
export const PARTS = 'PARTS';
export const BILL_TO = 'BILL_TO';
export const MIN_FIELD_LEVEL = 0;
export const MIN_DISCOUNT_LIMIT = 0;
export const MAX_DISCOUNT_LIMIT = 100;
export const DEFAULT_BRAND = 'V';
export const TECHNICIAN = 'TECHNICIAN';
export const SERVICE_JOB_ID = 'SERVICE_JOB_ID';
export const SERVICE_JOB_NAME = 'SERVICE_JOB_NAME';
export const RESERVATION_PARTS_ROW_LENGTH = 1;
export const BULK_UPLOAD = "Bulk Parts Upload";
export const ROW_SAVED = 'Row Saved';
export const ROW_EDIT_CLICKED = 'Row Edit Clicked';
export const BULK_PARTS_UPLOAD = 'Bulk Parts Upload';
export const IS_PARTY_LEVEL_DISCOUNT_ENABLE = 'IS_PARTY_LEVEL_DISCOUNT_ENABLE';
export const DISCOUNT_VAL = 'DISCOUNT_VAL';

export const PARTS_COLS = {
	ND_NR,
	ZAKAZKA_NR,
	X_VYROBEKND_OZN,
	X_SKLAD_OZN,
	X_ZAKAZKA_DRUH,
	PART_MRP,
	RRP_UNIT_PRICE,
	EAN_CODE,
	X_REZERVVLASTNI,
	CONVERTED_UNIT_OF_MEASUREMENT,
	TEXT,
	BASE_UNIT_OF_MEASUREMENT,
	CONVERTED_QUANTITY,
	PRICE_PER_CONVERTED_QUANTITY,
	IS_ADDITIONAL,
	BILL_TO,
	SP_DISCOUNTED,
	DISCOUNT_PERCENT,
	TECHNICIAN,
	SERVICE_JOB_ID,
	SERVICE_JOB_NAME,
	IS_PARTY_LEVEL_DISCOUNT_ENABLE,
	DISCOUNT_VAL,
};

export enum ORDER_STATUS {
	OPEN = 'OPEN',
	RELEASED = 'RELEASED',
	CLOSED = 'CLOSED'
}
